import axios from "axios";
import {MEDIA_SERVER} from "../constants/GlobalConst";
import {refresh} from "../services/auth/AuthAxios";
import {tokenResultAtom} from "../pages/login/entity";
import store, {authStatusAtom} from "../store";

export const mediaAxios = axios.create({
  baseURL: MEDIA_SERVER,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
  validateStatus: function (status) {
    return status !== 403 && status !== 401 && status <= 500;
  },
});
mediaAxios.interceptors.request.use(
  (config) => {
    const tokenAtom = store.get(tokenResultAtom)
    if (tokenAtom.accessToken) {
      config.headers.Authorization = `Bearer ${tokenAtom.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
)

let refreshPromise = null;

const redirectToLogin = () => {
  localStorage.removeItem("refreshToken");
  store.set(authStatusAtom, 'unauthenticated');
  store.set(tokenResultAtom, {
    accessToken: '',
    refreshToken: '',
    id: '',
    role: '',
    name: '',
    username: '',
    serverName: '',
  });
  window.location.replace('/');
};

const refreshAccessToken = async () => {
  const refreshResponse = await refresh();
  const {data, responseCode, statusCode} = refreshResponse || {};
  const refreshStatus = responseCode?.statusCode ?? statusCode;

  if (refreshStatus !== 200 || !data?.token?.accessToken) {
    throw new Error('사용자 인증 갱신에 실패했습니다.');
  }

  store.set(tokenResultAtom, {
    id: data.id,
    username: data.username,
    role: data.role,
    name: data.name,
    accessToken: data.token.accessToken,
    refreshToken: data.token.refreshToken,
  });

  return data.token.accessToken;
};

mediaAxios.interceptors.response.use(
    (response) => {
      return response.data;
    },
    async (error) => {
      const {config, response} = error;

      if (!response || !config) {
        return Promise.reject(error);
      }

      const {status} = response;
      const originalRequest = config;

      if (status === 403 || status === 401) {
        if (originalRequest._retry) {
          return Promise.reject(error);
        }

        originalRequest._retry = true;
        refreshPromise ||= refreshAccessToken().finally(() => {
          refreshPromise = null;
        });

        try {
          const accessToken = await refreshPromise;
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return mediaAxios(originalRequest);
        } catch (refreshError) {
          redirectToLogin();
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
);
